// extracted by mini-css-extract-plugin
export default {"container":"basketbomb_container__8CG6S","loading":"basketbomb_loading__Y4wnt","outerBox":"basketbomb_outerBox__95zjS","innerBox":"basketbomb_innerBox__zPk0x"};